import { vaultPostRequest } from '../helpers';
import type { IRenameCropRequest } from './rename-crop-request';
import type { IRenameCropResponse } from './rename-crop-response';
import { renameCropResponseSchema } from './rename-crop-response';

export async function renameCropApi(body: IRenameCropRequest): Promise<IRenameCropResponse> {
  return vaultPostRequest({ path: '/crop/rename', body, schema: renameCropResponseSchema });
}
